__turbopack_context__.v({
  "video": "HomePageHowItWorksVideo-module__NvXCGG__video",
});
